import { IOption } from 'components/forms/combobox/types'
import { Reducer } from 'redux'
import { IAction, IDriverState } from 'apps/fleet-planner/types'
import { FETCH_DRIVERS_ACTION_TYPES } from 'apps/fleet-planner/utils/actions/drivers'
import { ISuccessAction } from '../types/drivers'

const {
  FETCH_DRIVERS_FAILURE,
  FETCH_DRIVERS_REQUEST,
  FETCH_DRIVERS_SUCCESS,
} = FETCH_DRIVERS_ACTION_TYPES

const defaultState: IDriverState = {
  fetching: false,
  drivers: [],
  driversAutocomplete: [],
}

type DriversAction = IAction | ISuccessAction

const driversReducer: Reducer<IDriverState, DriversAction> = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_DRIVERS_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: undefined,
      }
    }

    case FETCH_DRIVERS_SUCCESS: {
      const {
        payload: { drivers = [] },
      } = (action || {}) as ISuccessAction
      return {
        ...state,
        drivers,
        driversAutocomplete: drivers.map(
          ({ id, name }): IOption => ({ id: id!.toString(), text: name || '' })
        ),
        fetching: false,
      }
    }

    case FETCH_DRIVERS_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    }

    default:
      return state
  }
}

export default driversReducer
